import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
  ValidationErrors,
  UntypedFormControl
} from '@angular/forms';
import * as moment from 'moment';

import { sanitizeServerUtcDate, MaxDate } from '@sd-portal/shared/util';
import { Leg } from './leg.model';

export class LegHobbsForm {
  hobbsStartMinutes: FormControl = new FormControl({ value: '', disabled: true });
  hobbsEndMinutes: FormControl = new FormControl('');
  hobbsDurationMinutes: FormControl = new UntypedFormControl({ value: '' });
  hobbsOutTime: FormControl = new FormControl('');
  hobbsInTime: FormControl = new FormControl('');
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(leg?: Leg, includeControlValidation: boolean = false) {
    if (includeControlValidation) {
      const now = moment.utc();
      this.hobbsOutTime.setValidators([Validators.required, MaxDate(now)]);
      this.hobbsInTime.setValidators([Validators.required, MaxDate(now)]);
      this.hobbsEndMinutes.setValidators([Validators.required, Validators.min(0)]);
    }

    if (leg) {
      this.hobbsStartMinutes.setValue(leg.hobbsStartMinutes);
      this.hobbsEndMinutes.setValue(leg.hobbsEndMinutes);
      this.hobbsDurationMinutes.setValue(leg.hobbsDurationMinutes);

      // outTime is hobbsOutTime
      if (leg.outTime) {
        this.hobbsOutTime.setValue(sanitizeServerUtcDate(leg.outTime));
      }

      if (leg.hobbsInTime) {
        this.hobbsInTime.setValue(sanitizeServerUtcDate(leg.hobbsInTime));
      }
    }
  }
}

export function validateHobbs(): ValidatorFn {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const hobbsStartControl = formGroup.get('hobbsStartMinutes') as FormControl;
    const hobbsEndControl = formGroup.get('hobbsEndMinutes') as FormControl;

    let hobbsStart: number | null = null;
    let hobbsEnd: number | null = null;

    if (hobbsStartControl) {
      hobbsStart = +hobbsStartControl.value;
    }

    if (hobbsEndControl) {
      hobbsEnd = +hobbsEndControl.value;
    }

    if (hobbsStart && hobbsEnd && hobbsStart > hobbsEnd) {
      hobbsEndControl.setErrors({ customMessage: 'Hobbs End cannot be less than Hobbs Start' });
    }

    return null;
  };
}
